/**
 * Generates a version 4 universal unique identifier.
 *
 * Gist: https://gist.github.com/akleiber/7c1d19135360af38675d6987a93f005c
 *
 * @param {Number} a An optional number to generate a substring.
 * @returns {String} The generated uuid of the form `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`
 */
function generateUuid(a) {
  return a
    ? (a ^ ((Math.random() * 16) >> (a / 4))).toString(16)
    : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, generateUuid)
}

export default generateUuid
